import { Component } from '@angular/core';

@Component({
    selector: 'mnc-empty',
    template: '',
    standalone: false
})
export class EmptyComponent {
  constructor() {}
}
